<template>
    <div id="modal">
        <h2>Get the results now!</h2>
        <div class="input-group mb-3">
            <input type="text" v-model="name" class="form-control text-field-input" v-on:focus="nameInputFocus" v-bind:class="{'text-danger': notValidName, 'invalid-input': notValidName}" id="name" placeholder="First + Last Name" aria-label="Name" aria-describedby="basic-addon1">
        </div>
        <div class="input-group mb-3">
            <input type="text" v-model="email" class="form-control text-field-input" v-on:focus="emailInputFocus" v-bind:class="{'text-danger': notValidEmail, 'invalid-input': notValidEmail}" id="Email" placeholder="Email" aria-label="Email" aria-describedby="basic-addon2">
        </div>
        <div class="input-group mb-3" style="margin-bottom: 8px !important;">
            <input type="text" v-model="phone" class="form-control text-field-input" v-on:focus="phoneInputFocus" v-bind:class="{'text-danger': notValidPhone, 'invalid-input': notValidPhone}" id="Phone" placeholder="Phone" aria-label="Phone" aria-describedby="basic-addon3">
        </div>
        <div class="radio-group-user-type">
            I'm an:
            <div class="form-check form-check-inline" style="margin-right: 0;">
                <label class="form-check-label" for="inlineRadio1">Investor</label>
                <input v-model="userType" class="form-check-input" style="margin-right: 0;" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Investor">
            </div>
            or
            <div class="form-check form-check-inline" style="margin-right: 0;">
                <label class="form-check-label" for="inlineRadio2">Advisor</label>
                <input v-model="userType" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="Advisor">
            </div>
        </div>
        <p class="info-row">
            A copy of your results will be emailed to you.
            The Calculator will also be unlocked for future use
        </p>
        <p>By continuing you agree to our <span><a href="https://soundproperty.com.au/legal/" target="_blank">privacy policy</a></span></p>
        <button v-on:click="sendData" type="button" class="btn">Show Cashflow Estimate</button>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "modal",
        data () {
            return {
                name: '',
                email: '',
                phone: '',
                check: false,
                notValidName: false,
                notValidEmail: false,
                notValidPhone: false,
                userType: 'Investor'
            }
        },
        methods: {
            sendData: function() {

                var validEmail = this.emailValidation();
                var validName = this.nameValidation();

                if (validEmail && validName) {
                    axios.post('/index.php/wp-json/cashflow-calculator/cashflow-calculator-data/', {
                        calculator_path: this.$route.path,
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        user_type: this.userType,
                        wants_contact: Number(this.check),
                        property_suburb: this.propertySuburbValue,
                        purchase_price: '$' + this.purchasePriceValue.toLocaleString('en-US',{useGrouping:true}),
                        deposit_source: this.depositSourceValue,
                        deposit_amount: '$' + this.depositAmountValue.toLocaleString('en-US',{useGrouping:true}),
                        deposit_percentage: this.depositPercentageValue + '%',
                        stamp_duty: '$' + this.stampDutyValue.toLocaleString('en-US',{useGrouping:true}),
                        legal_fees: '$' + this.legalFeesValue.toLocaleString('en-US',{useGrouping:true}),
                        prepurchase_inspections: '$' + this.prepurchaseInspectionsValue.toLocaleString('en-US',{useGrouping:true}),
                        other_fees_and_costs: '$' + this.otherFeesCostsValue.toLocaleString('en-US',{useGrouping:true}),
                        total_purchase_costs: '$' + this.totalPurchaseCostsValue.toLocaleString('en-US',{useGrouping:true}),
                        rental_income_amount: '$' + this.rentalIncomeAmountValue.toLocaleString('en-US',{useGrouping:true}),
                        rental_income_percentage: this.rentalIncomePercentageValue + '%',
                        rental_income_annual: '$' + this.rentalIncomeAnnualValue.toLocaleString('en-US',{useGrouping:true}),
                        council_rates: '$' + this.councilRatesValue.toLocaleString('en-US',{useGrouping:true}),
                        building_insurance_or_strata_fees: '$' + this.buildingInsuranceOrStrataFeesValue.toLocaleString('en-US',{useGrouping:true}),
                        other_expenses: '$' + this.otherExpensesValue.toLocaleString('en-US',{useGrouping:true}),
                        property_management: this.propertyManagementValue + '%',
                        vacancy_period: this.vacancyPeriodValue,
                        total_income: '$' + this.totalIncomeValue.toLocaleString('en-US',{useGrouping:true}),
                        loan_amount: '$' + this.loanAmountValue.toLocaleString('en-US',{useGrouping:true}),
                        loan_to_value_ratio: this.loanToValueRatioValue + '%',
                        lenders_mortgage_insurance: '$' + this.lendersMortgageInsuranceValue.toLocaleString('en-US',{useGrouping:true}),
                        loan_type: this.loanTypeValue,
                        loan_term: this.loanTermValue,
                        interest_rate: this.interestRateValue + '%',
                        annual_interest_repayments: '$' + this.annualInterestRepaymentsValue.toLocaleString('en-US',{useGrouping:true}),
                        annual_principal_repayments: '$' + this.annualPrincipalRepaymentsValue.toLocaleString('en-US',{useGrouping:true}),
                        annual_interest_on_equity_funds: '$' + this.annualInterestOnEquityFundsValue.toLocaleString('en-US',{useGrouping:true}),
                        total_expenses: '$' + this.totalExpensesValue.toLocaleString('en-US',{useGrouping:true}),
                        individual_gross_income: '$' + this.individualGrossIncomeValue.toLocaleString('en-US',{useGrouping:true}),
                        tax_rate: this.taxRateValue + '%',
                        property_bought: this.propertyBoughtValue,
                        nearest_capital_city: this.nearestCapitalCityValue,
                        standard_of_finish: this.standardOfFinishValue,
                        property_type: this.propertyTypeValue,
                        purchase_date: this.purchaseDateValue,
                        construction_year: Number(this.constructionYearValue),
                        estimated_amount: '$' + this.estimatedAmountValue.toLocaleString('en-US',{useGrouping:true}),
                        weekly_rental_income: this.weeklyRentalIncomeValue,
                        weekly_pre_total_expenses: this.weeklyPreTotalExpensesValue,
                        weekly_pre_cashflow_estimate: this.weeklyPreCashflowEstimateValue,
                        weekly_post_total_claimable_expenses: this.weeklyPostTotalClaimableExpensesValue,
                        weekly_post_depreciation: this.weeklyPostDepreciationValue,
                        weekly_post_net_taxable_amount: this.weeklyPostNetTaxableAmountValue,
                        weekly_post_tax_rebate: this.weeklyPostTaxRebateValue,
                        weekly_post_cashflow_estimate: this.weeklyPostCashflowEstimateValue,
                        annual_rental_income: this.annualRentalIncomeValue,
                        annual_pre_total_expenses: this.annualPreTotalExpensesValue,
                        annual_pre_cashflow_estimate: this.annualPreCashflowEstimateValue,
                        annual_post_total_claimable_expenses: this.annualPostTotalClaimableExpensesValue,
                        annual_post_depreciation: this.annualPostDepreciationValue,
                        annual_post_net_taxable_amount: this.annualPostNetTaxableAmountValue,
                        annual_post_tax_rebate: this.annualPostTaxRebateValue,
                        annual_post_cashflow_estimate: this.annualPostCashflowEstimateValue,
                        capital_growth: this.capitalGrowthValue + '%',
                        property_value_year1: '$' + this.propertyValueYear1.toLocaleString('en-US',{useGrouping:true}),
                        loan_year1: '$' + this.loanValueYear1.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year1: '$' + this.totalEquityValueYear1.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year2: '$' + this.propertyValueYear2.toLocaleString('en-US',{useGrouping:true}),
                        loan_year2: '$' + this.loanValueYear2.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year2: '$' + this.totalEquityValueYear2.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year3: '$' + this.propertyValueYear3.toLocaleString('en-US',{useGrouping:true}),
                        loan_year3: '$' + this.loanValueYear3.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year3: '$' + this.totalEquityValueYear3.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year4: '$' + this.propertyValueYear4.toLocaleString('en-US',{useGrouping:true}),
                        loan_year4: '$' + this.loanValueYear4.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year4: '$' + this.totalEquityValueYear4.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year5: '$' + this.propertyValueYear5.toLocaleString('en-US',{useGrouping:true}),
                        loan_year5: '$' + this.loanValueYear5.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year5: '$' + this.totalEquityValueYear5.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year6: '$' + this.propertyValueYear6.toLocaleString('en-US',{useGrouping:true}),
                        loan_year6: '$' + this.loanValueYear6.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year6: '$' + this.totalEquityValueYear6.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year7: '$' + this.propertyValueYear7.toLocaleString('en-US',{useGrouping:true}),
                        loan_year7: '$' + this.loanValueYear7.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year7: '$' + this.totalEquityValueYear7.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year8: '$' + this.propertyValueYear8.toLocaleString('en-US',{useGrouping:true}),
                        loan_year8: '$' + this.loanValueYear8.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year8: '$' + this.totalEquityValueYear8.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year9: '$' + this.propertyValueYear9.toLocaleString('en-US',{useGrouping:true}),
                        loan_year9: '$' + this.loanValueYear9.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year9: '$' + this.totalEquityValueYear9.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year10: '$' + this.propertyValueYear10.toLocaleString('en-US',{useGrouping:true}),
                        loan_year10: '$' + this.loanValueYear10.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year10: '$' + this.totalEquityValueYear10.toLocaleString('en-US',{useGrouping:true}),
                        property_value_year11: '$' + this.propertyValueYear11.toLocaleString('en-US',{useGrouping:true}),
                        loan_year11: '$' + this.loanValueYear11.toLocaleString('en-US',{useGrouping:true}),
                        total_equity_year11: '$' + this.totalEquityValueYear11.toLocaleString('en-US',{useGrouping:true})
                    }).then(response => {})
                        .catch(e => {

                        });

                    this.$store.commit('phoneNumber', this.phone);
                    this.$store.commit('email', this.email);
                    this.$store.commit('name', this.name);
                    this.$store.commit('userType', this.userType);
                    this.$store.commit('modalVisibility', false);

                    this.$emit('showCashflowEstimate');

                    if (typeof gtag_report_conversion === 'function') {
                        gtag_report_conversion();
                    }

                    if (typeof gtag === 'function') {
                        gtag('event', 'Click', {
                            'event_category': 'CashflowCalculator',
                            'event_label': 'Step4-ShowEstimate'});
                        gtag('config', 'UA-50707122-1', {'page_path': '/calculator/step4-converted'});
                    }
                }
            },
            emailValidation() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (re.test(String(this.email).toLowerCase())) {
                    this.notValidEmail = false;
                    return true;
                } else {
                    this.notValidEmail = true;
                    return false;
                }
            },
            nameValidation() {

                if (this.name.length > 0) {
                    this.notValidName = false;
                    return true;
                } else {
                    this.notValidName = true;
                    return false;
                }
            },
            phoneValidation() {
                if (this.check) {
                    if (this.phone.length > 0) {
                        this.notValidPhone = false;
                        return true;
                    }
                    this.notValidPhone = true;
                    return false;
                }
                this.notValidPhone = false;
                return true;
            },
            emailInputFocus() {
                this.notValidEmail = false;
            },
            nameInputFocus() {
                this.notValidName = false;
            },
            phoneInputFocus() {
                this.notValidPhone = false;
            }
        },
        computed: {
            propertySuburbValue() {
                return this.$store.state.purchaseCosts.getPropertySuburb();
            },
            purchasePriceValue() {
                return this.$store.state.purchaseCosts.getPurchasePrice();
            },
            depositSourceValue() {
                return this.$store.state.purchaseCosts.getDepositSource();
            },
            depositAmountValue() {
                return this.$store.state.purchaseCosts.getDepositAmount();
            },
            depositPercentageValue() {
                return this.$store.state.purchaseCosts.getDepositPercentage();
            },
            stampDutyValue() {
                return this.$store.state.purchaseCosts.getStampDuty();
            },
            legalFeesValue() {
                return this.$store.state.purchaseCosts.getLegalFees();
            },
            prepurchaseInspectionsValue() {
                return this.$store.state.purchaseCosts.getPrepurchaseInspections();
            },
            otherFeesCostsValue() {
                return this.$store.state.purchaseCosts.getOtherFeesCosts();
            },
            totalPurchaseCostsValue() {
                return this.$store.state.purchaseCosts.getTotal();
            },
            rentalIncomeAmountValue() {
                return this.$store.state.incomeAndExpenses.getRentalIncomeAmount();
            },
            rentalIncomePercentageValue() {
                return this.$store.state.incomeAndExpenses.getRentalIncomePercentage();
            },
            rentalIncomeAnnualValue() {
                return this.$store.state.incomeAndExpenses.getRentalIncomeAnnual();
            },
            councilRatesValue() {
                return this.$store.state.incomeAndExpenses.getCouncilRates();
            },
            buildingInsuranceOrStrataFeesValue() {
                return this.$store.state.incomeAndExpenses.getBuildingInsuranceOrStrataFees();
            },
            otherExpensesValue() {
                return this.$store.state.incomeAndExpenses.getOtherExpenses();
            },
            propertyManagementValue() {
                return this.$store.state.incomeAndExpenses.getPropertyManagement();
            },
            vacancyPeriodValue() {
                return this.$store.state.incomeAndExpenses.getVacancyPeriod();
            },
            totalIncomeValue() {
                return this.$store.state.incomeAndExpenses.getTotal();
            },
            loanAmountValue() {
                return this.$store.state.incomeAndExpenses.getLoanAmount();
            },
            loanToValueRatioValue() {
                return this.$store.state.incomeAndExpenses.getLoanToValueRatio();
            },
            loanTypeValue() {
                return this.$store.state.incomeAndExpenses.getLoanType();
            },
            loanTermValue() {
                return this.$store.state.incomeAndExpenses.getLoanTerm();
            },
            lendersMortgageInsuranceValue() {
                return this.$store.state.incomeAndExpenses.getLendersMortgageInsurance();
            },
            interestRateValue() {
                return this.$store.state.incomeAndExpenses.getInterestRate();
            },
            annualInterestRepaymentsValue() {
                return this.$store.state.incomeAndExpenses.getAnnualInterestRepayments();
            },
            annualPrincipalRepaymentsValue() {
                return this.$store.state.incomeAndExpenses.getAnnualPrincipalRepayments();
            },
            annualInterestOnEquityFundsValue() {
                return this.$store.state.incomeAndExpenses.getAnnualInterestOnEquityFunds();
            },
            totalExpensesValue() {
                return this.$store.state.incomeAndExpenses.getTotalExpenses();
            },
            individualGrossIncomeValue() {
                return this.$store.state.taxFactors.getIndividualGrossIncome();
            },
            taxRateValue() {
                return this.$store.state.taxFactors.getTaxRate();
            },
            propertyBoughtValue() {
                return this.$store.state.taxFactors.getPropertyBought();
            },
            nearestCapitalCityValue() {
                return this.$store.state.taxFactors.getNearestCapitalCity();
            },
            propertyTypeValue() {
                return this.$store.state.taxFactors.getPropertyType();
            },
            purchaseDateValue() {
                return this.$store.state.taxFactors.getPurchaseDate();
            },
            constructionYearValue() {
                return this.$store.state.taxFactors.getConstructionYear().toString();
            },
            standardOfFinishValue() {
                return this.$store.state.taxFactors.getStandardOfFinish();
            },
            estimatedAmountValue() {
                return this.$store.state.taxFactors.getEstimatedAmount();
            },
            weeklyRentalIncomeValue() {
                return "$" + this.$store.state.results.getWeeklyRentalIncome().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPreTotalExpensesValue() {
                return "$" + this.$store.state.results.getWeeklyPreTotalExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPreCashflowEstimateValue() {
                var weeklyPreCashflowEstimate = this.$store.state.results.getWeeklyPreCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPreCashflowEstimate.includes('-')) {
                    weeklyPreCashflowEstimate = weeklyPreCashflowEstimate.slice(0, 1) + '$' + weeklyPreCashflowEstimate.slice(1, weeklyPreCashflowEstimate.length);
                } else {
                    weeklyPreCashflowEstimate = "$" + weeklyPreCashflowEstimate;
                }
                return weeklyPreCashflowEstimate;
            },
            weeklyPostTotalClaimableExpensesValue() {
                return "$" + this.$store.state.results.getWeeklyPostTotalClaimableExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPostDepreciationValue() {
                return "$" + this.$store.state.results.getWeeklyPostDeprecation().toLocaleString('en-US',{useGrouping:true});
            },
            weeklyPostNetTaxableAmountValue() {
                var weeklyPostNetTaxableAmount = this.$store.state.results.getWeeklyPostNetTaxableAmount().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostNetTaxableAmount.includes('-')) {
                    weeklyPostNetTaxableAmount = weeklyPostNetTaxableAmount.slice(0, 1) + '$' + weeklyPostNetTaxableAmount.slice(1, weeklyPostNetTaxableAmount.length);
                } else  {
                    weeklyPostNetTaxableAmount = "$" + weeklyPostNetTaxableAmount
                }
                return weeklyPostNetTaxableAmount;
            },
            weeklyPostTaxRebateValue() {
                var weeklyPostTaxRebate = this.$store.state.results.getWeeklyPostTaxRebate().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostTaxRebate.includes('-')) {
                    weeklyPostTaxRebate = weeklyPostTaxRebate.slice(0, 1) + '$' + weeklyPostTaxRebate.slice(1, weeklyPostTaxRebate.length);
                } else  {
                    weeklyPostTaxRebate = "$" + weeklyPostTaxRebate
                }
                return weeklyPostTaxRebate;
            },
            weeklyPostCashflowEstimateValue() {
                var weeklyPostCashflowEstimate = this.$store.state.results.getWeeklyPostCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (weeklyPostCashflowEstimate.includes('-')) {
                    weeklyPostCashflowEstimate = weeklyPostCashflowEstimate.slice(0, 1) + '$' + weeklyPostCashflowEstimate.slice(1, weeklyPostCashflowEstimate.length);
                } else  {
                    weeklyPostCashflowEstimate = "$" + weeklyPostCashflowEstimate
                }
                return weeklyPostCashflowEstimate;
            },
            annualRentalIncomeValue() {
                return "$" + this.$store.state.results.getAnnualRentalIncome().toLocaleString('en-US',{useGrouping:true});
            },
            annualPreTotalExpensesValue() {
                return "$" + this.$store.state.results.getAnnualPreTotalExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            annualPreCashflowEstimateValue() {
                var annualPreCashflowEstimate = this.$store.state.results.getAnnualPreCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (annualPreCashflowEstimate.includes('-')) {
                    annualPreCashflowEstimate = annualPreCashflowEstimate.slice(0, 1) + '$' + annualPreCashflowEstimate.slice(1, annualPreCashflowEstimate.length);
                } else  {
                    annualPreCashflowEstimate = "$" + annualPreCashflowEstimate
                }
                return annualPreCashflowEstimate;
            },
            annualPostTotalClaimableExpensesValue() {
                return "$" + this.$store.state.results.getAnnualPostTotalClaimableExpenses().toLocaleString('en-US',{useGrouping:true});
            },
            annualPostDepreciationValue() {
                return "$" + this.$store.state.results.getAnnualPostDeprecation().toLocaleString('en-US',{useGrouping:true});
            },
            annualPostNetTaxableAmountValue() {
                var annualPostNetTaxableAmount = this.$store.state.results.getAnnualPostNetTaxableAmount().toLocaleString('en-US',{useGrouping:true});
                if (annualPostNetTaxableAmount.includes('-')) {
                    annualPostNetTaxableAmount = annualPostNetTaxableAmount.slice(0, 1) + '$' + annualPostNetTaxableAmount.slice(1, annualPostNetTaxableAmount.length);
                } else  {
                    annualPostNetTaxableAmount = "$" + annualPostNetTaxableAmount
                }
                return annualPostNetTaxableAmount;
            },
            annualPostTaxRebateValue() {
                var annualPostTaxRebate = this.$store.state.results.getAnnualPostTaxRebate().toLocaleString('en-US',{useGrouping:true});
                if (annualPostTaxRebate.includes('-')) {
                    annualPostTaxRebate = annualPostTaxRebate.slice(0, 1) + '$' + annualPostTaxRebate.slice(1, annualPostTaxRebate.length);
                } else  {
                    annualPostTaxRebate = "$" + annualPostTaxRebate
                }
                return annualPostTaxRebate;
            },
            annualPostCashflowEstimateValue() {
                var annualPostCashflowEstimate = this.$store.state.results.getAnnualPostCashflowEstimate().toLocaleString('en-US',{useGrouping:true});
                if (annualPostCashflowEstimate.includes('-')) {
                    annualPostCashflowEstimate = annualPostCashflowEstimate.slice(0, 1) + '$' + annualPostCashflowEstimate.slice(1, annualPostCashflowEstimate.length);
                } else  {
                    annualPostCashflowEstimate = "$" + annualPostCashflowEstimate
                }
                return annualPostCashflowEstimate;
            },
            capitalGrowthValue() {
                return this.$store.state.results.getCapitalGrowth();
            },
            propertyValueYear1() {
                return this.$store.state.results.getPropertyValueYear1();
            },
            loanValueYear1() {
                return this.$store.state.results.getLoanYear1();
            },
            totalEquityValueYear1() {
                return this.$store.state.results.getTotalEquityYear1();
            },
            propertyValueYear2() {
                return this.$store.state.results.getPropertyValueYear2();
            },
            loanValueYear2() {
                return this.$store.state.results.getLoanYear2();
            },
            totalEquityValueYear2() {
                return this.$store.state.results.getTotalEquityYear2();
            },
            propertyValueYear3() {
                return this.$store.state.results.getPropertyValueYear3();
            },
            loanValueYear3() {
                return this.$store.state.results.getLoanYear3();
            },
            totalEquityValueYear3() {
                return this.$store.state.results.getTotalEquityYear3();
            },
            propertyValueYear4() {
                return this.$store.state.results.getPropertyValueYear4();
            },
            loanValueYear4() {
                return this.$store.state.results.getLoanYear4();
            },
            totalEquityValueYear4() {
                return this.$store.state.results.getTotalEquityYear4();
            },
            propertyValueYear5() {
                return this.$store.state.results.getPropertyValueYear5();
            },
            loanValueYear5() {
                return this.$store.state.results.getLoanYear5();
            },
            totalEquityValueYear5() {
                return this.$store.state.results.getTotalEquityYear5();
            },
            propertyValueYear6() {
                return this.$store.state.results.getPropertyValueYear6();
            },
            loanValueYear6() {
                return this.$store.state.results.getLoanYear6();
            },
            totalEquityValueYear6() {
                return this.$store.state.results.getTotalEquityYear6();
            },
            propertyValueYear7() {
                return this.$store.state.results.getPropertyValueYear7();
            },
            loanValueYear7() {
                return this.$store.state.results.getLoanYear7();
            },
            totalEquityValueYear7() {
                return this.$store.state.results.getTotalEquityYear7();
            },
            propertyValueYear8() {
                return this.$store.state.results.getPropertyValueYear8();
            },
            loanValueYear8() {
                return this.$store.state.results.getLoanYear8();
            },
            totalEquityValueYear8() {
                return this.$store.state.results.getTotalEquityYear8();
            },
            propertyValueYear9() {
                return this.$store.state.results.getPropertyValueYear9();
            },
            loanValueYear9() {
                return this.$store.state.results.getLoanYear9();
            },
            totalEquityValueYear9() {
                return this.$store.state.results.getTotalEquityYear9();
            },
            propertyValueYear10() {
                return this.$store.state.results.getPropertyValueYear10();
            },
            loanValueYear10() {
                return this.$store.state.results.getLoanYear10();
            },
            totalEquityValueYear10() {
                return this.$store.state.results.getTotalEquityYear10();
            },
            propertyValueYear11() {
                return this.$store.state.results.getPropertyValueYear11();
            },
            loanValueYear11() {
                return this.$store.state.results.getLoanYear11();
            },
            totalEquityValueYear11() {
                return this.$store.state.results.getTotalEquityYear11();
            }
        },
    }
</script>

<style scoped>

    #modal {
        width: 400px;
        background-color: #fff;
        color: #465978;
        border: 0.5px solid #465978;
        position: absolute;
        left: 50%;
        margin-left: -200px;
        z-index: 1;
    }

    h2 {
        width: 80%;
        margin: 0 auto;
        margin-bottom: 30px;
        margin-top: 15px;
        font-weight: bold;
        text-align: center;
    }

    .input-group {
        width: 65%;
        margin: 0 auto;
    }

    .text-field-input {
        position: relative !important;
        opacity: 1 !important;
        height: 38px !important;
    }

    p {
        width: 65%;
        margin: 0 auto;
        font-size: 12px;
        margin-bottom: 15px;
    }

    span {
        text-decoration: underline;
    }

    .info-row {
        display: block;
        position: relative;
        width: 65%;
        margin-bottom: 12px;
        font-size: 14px;
        line-height: 16px;
        margin-left: auto;
        margin-right: auto;
    }

    .btn {
        width: 70%;
        margin: 0 auto;
        background-color: #465978;
        color: #fff;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 30px;
        display: block;
    }

    .radio-group-user-type {
        width: 65%;
        margin: 0 auto;
        margin-bottom: 1rem !important;
    }

    .form-check-label {
        margin-right: 0.3125rem;
    }

    .invalid-input {
        background-color: #ffcccc;
    }

    @media (max-width: 420px) {

        #modal {
            width: 320px;
            margin-left: -160px;
        }

        .btn {
            font-size: 16px;
        }

        .radio-group-user-type {
            font-size: 14px;
        }
    }

    @media (max-width: 350px) {

        #modal {
            width: 280px;
            margin-left: -140px;
        }

        .btn {
            font-size: 14px;
        }

        .radio-group-user-type {
            font-size: 12px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/Modal.vue